import type { Listing } from "../types/domain";
import { Button } from "./ui/Button";
import { Card } from "./ui/Card";
import { StatusBadge } from "./ui/StatusBadge";

interface ListingCardProps {
  listing: Listing;
  sellerName: string;
}

export function ListingCard({ listing, sellerName }: ListingCardProps) {
  return (
    <Card className="grid gap-5 p-5 md:grid-cols-[180px_1fr]">
      <div className="grid min-h-40 place-items-center rounded-2xl bg-slate-100 font-black uppercase tracking-widest text-slate-600">Rx</div>
      <div>
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <h3 className="text-2xl font-black text-slate-950">{listing.name} {listing.dosage}</h3>
            <p className="mt-2 font-mono text-xs uppercase tracking-wider text-slate-500">NDC {listing.ndc} · Lot {listing.lot}</p>
          </div>
          <StatusBadge status={listing.packetStatus} />
        </div>
        <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 p-4">
          <span className="text-3xl font-black text-slate-950">${listing.unitPrice.toLocaleString()}</span><span className="text-slate-600"> / unit</span>
        </div>
        <div className="mt-4 grid gap-3 text-sm text-slate-700 md:grid-cols-3">
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3"><span className="block text-xs uppercase tracking-widest text-slate-500">Expiration</span>{new Date(listing.expiresAt).toLocaleDateString(undefined, { month: "short", year: "numeric" })}</div>
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3"><span className="block text-xs uppercase tracking-widest text-slate-500">Qty</span>{listing.quantity} units</div>
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3"><span className="block text-xs uppercase tracking-widest text-slate-500">Ships</span>{listing.shipsInHours} hrs</div>
        </div>
        <p className="mt-4 text-sm text-slate-600">Seller: <strong className="text-slate-950">{sellerName}</strong></p>
        <div className="mt-4 flex gap-3">
          <Button href={`/marketplace/listings/${listing.id}`} variant="secondary">Bid</Button>
          <Button href={`/checkout/${listing.id}`}>Buy now</Button>
        </div>
      </div>
    </Card>
  );
}
